import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector } from '@xstate/react';
import { boxMembersQuery } from 'networking/mindfeed/queries/boxMembers';
import { boxesQuery } from 'networking/mindfeed/queries/boxes';
import { SpaceActor, Selectors } from 'xstate/actors/SpaceActor';
import { notify, NotificationType } from 'xstate/actors/NotificationActor';
import { deleteBoxMember } from 'networking/mindfeed/services/box.service';
import { BoxId } from 'models/Box';
import { UserId } from 'models/User';

type Variables = {
  boxId: BoxId;
  memberId: UserId;
};

const useDeleteBoxMember = () => {
  const queryClient = useQueryClient();
  const spaceId = useSelector(SpaceActor, Selectors.selectedSpaceId);

  const onSuccessCallback = async (_data: void, variables: Variables) => {
    // The modal's list, and the box list that carries members for the rows.
    queryClient.invalidateQueries({
      queryKey: boxMembersQuery(variables.boxId).queryKey,
    });
    queryClient.invalidateQueries({ queryKey: boxesQuery(spaceId).queryKey });

    // Notify User
    notify(NotificationType.BOX_MEMBER_DELETED);
  };

  return useMutation<void, Error, Variables>({
    mutationFn: (variables) =>
      deleteBoxMember(variables.boxId, variables.memberId),
    onSuccess: onSuccessCallback,
  });
};

export default useDeleteBoxMember;
